<p-toast></p-toast>
<h2 class="page-title">
  {{ "i18n.base.user-management.header" | translate }}
</h2>

<div class="data-table">
  <p-toolbar>
    <ng-template pTemplate="left">
      <p-button
        label="{{ 'i18n.base.user-management.buttons.add-web' | translate }}"
        icon="pi pi-plus"
        *ngIf="authService.isUserAdmin()"
        (onClick)="openNew()"
      ></p-button>
    </ng-template>
    <ng-template pTemplate="right">
      <app-search-field
        (searchTextChanged)="onSearchTextChanged($event)"
      ></app-search-field>
    </ng-template>
  </p-toolbar>

  <p-table
    [value]="data"
    [rows]="pagedQuery.pageSize"
    [paginator]="true"
    [globalFilterFields]="globalFilters"
    [rowHover]="true"
    dataKey="userId"
    [lazy]="true"
    (onFilter)="onFilter($event)"
    (onPage)="onPageChange($event)"
    (onSort)="onSort($event)"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Users"
    [showCurrentPageReport]="true"
    [totalRecords]="totalNoOfRecords"
    [rowsPerPageOptions]="pagedQuery.getPageSizes()"
    [filterDelay]="0"
    [filters]="columnFilters"
    styleClass="dt-grid"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="firstname">
          {{ "i18n.shared.fields.firstname" | translate }}
          <p-sortIcon field="firstname"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="firstname"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th pSortableColumn="lastname">
          {{ "i18n.shared.fields.lastname" | translate }}
          <p-sortIcon field="lastname"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="lastname"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th pSortableColumn="email">
          {{ "i18n.shared.fields.email" | translate }}
          <p-sortIcon field="email"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="email"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th pSortableColumn="client.name">
          {{ "i18n.base.user-management.column-headers.client" | translate }}
          <p-sortIcon field="client.name"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="client.name"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th pSortableColumn="roles">
          {{ "i18n.base.user-management.column-headers.role" | translate }}
          <p-sortIcon field="roles"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="roles"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th pSortableColumn="enabled" class="dt-center">
          {{ "i18n.base.user-management.column-headers.enabled" | translate }}
          <p-sortIcon field="enabled"></p-sortIcon>
          <p-columnFilter
            type="boolean"
            field="enabled"
            display="menu"
          ></p-columnFilter>
        </th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-user>
      <tr>
        <td>{{ user.firstname }}</td>
        <td>{{ user.lastname }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.client?.name }}</td>
        <td>{{ getRoleLabels(user.roles) }}</td>
        <td class="dt-center">
          <p-tag
            [value]="user.enabled ? 'Yes' : 'No'"
            [severity]="user.enabled ? 'success' : 'danger'"
          ></p-tag>
        </td>
        <td>
          <div class="grid-commands">
            <p-button
              icon="pi pi-pencil"
              [rounded]="true"
              [outlined]="true"
              severity="success"
              (onClick)="editItem(user)"
            ></p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7">No Users found</td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog
    [(visible)]="itemDialog"
    [style]="{ width: '450px' }"
    [modal]="true"
    styleClass="p-fluid"
  >
    <ng-template pTemplate="header">
      <div class="dialog-header">
        <span class="dialog-title">
          {{ "i18n.base.user-management.edit-user" | translate }}
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="content">
      <app-user-edit-form
        *ngIf="form"
        [form]="form"
        [clients]="clients"
        [roles]="RoleOptions"
        [subscriptions]="subscriptions"
        [originalRoles]="originalRoles"
        [showRoleDropdown]="isCreateMode"
        [showClientAdminCheckbox]="
          !isCreateMode &&
          (authService.isUserClientAdmin() || authService.isUserAdmin())
        "
        [showDeliveryExecCheckbox]="
          !isCreateMode && authService.isUserClientAdmin()
        "
        [showSubscriptionDropdown]="authService.isUserAdmin()"
        [currentSubscriptionName]="getCurrentSubscriptionName()"
      ></app-user-edit-form>
    </ng-template>

    <ng-template pTemplate="footer">
      <p-button
        label="Cancel"
        icon="pi pi-times"
        [text]="true"
        (onClick)="hideDialog()"
      ></p-button>
      <p-button
        label="Save"
        icon="pi pi-check"
        [text]="true"
        (onClick)="saveUser()"
        [disabled]="!form.valid"
      ></p-button>
    </ng-template>
  </p-dialog>
</div>
